import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

// 상수 정의
export const PRD3031_R01_SUBTOTAL_LEVELS = {
    ITEM: 1,
    DATE: 2,
    DETAIL: 3,
} as const;

export const PRD3031_R01_SUBTOTAL_TYPES = {
    ITEM: 'item',
    DATE: 'date',
} as const;

export interface PRD3031_R01Dto extends ProductResultDto {
    compNm: string;
    orderTypeNm: string;
    workplaceNm: string;
    jobTeamNm: string;
    itemSpec: string;
    itemUnit: string;
    empNm: string;
    badQty: number;
    acceptQty: number;
    brandCd: string;
    brandNm: string;
    
    // 백엔드 추가 필드들
    startDate?: string;
    endDate?: string;
    codeEntity?: any | null;
}

export interface PRD3031_R01SubtotalRow extends PRD3031_R01Dto {
    count: number;
    isSubtotal: true;
    subtotalType: typeof PRD3031_R01_SUBTOTAL_TYPES.ITEM | typeof PRD3031_R01_SUBTOTAL_TYPES.DATE;
    level: typeof PRD3031_R01_SUBTOTAL_LEVELS.ITEM | typeof PRD3031_R01_SUBTOTAL_LEVELS.DATE;
}

/**
 * 품목별 소계 행 데이터 인터페이스
 */
export interface PRD3031_R01ItemSubtotalRow extends PRD3031_R01SubtotalRow {
}

/**
 * 생산일자별 소계 행 데이터 인터페이스
 */
export interface PRD3031_R01DateSubtotalRow extends PRD3031_R01SubtotalRow {
    dateCount: number;      // 해당 일자의 행 개수
}

/**
 * 그리드에 표시할 통합 데이터 타입
 */
export type PRD3031_R01GridRowData = 
    | PRD3031_R01ItemSubtotalRow 
    | PRD3031_R01DateSubtotalRow
    | (PRD3031_R01Dto & { isSubtotal: false; level: typeof PRD3031_R01_SUBTOTAL_LEVELS.DETAIL });

/**
 * 품목별 소계 계산 데이터 인터페이스
 */
export interface PRD3031_R01SubtotalData {
    itemCd: string;        // 품목코드
    itemSpec: string;      // 품명
    itemUnit: string;      // 단위
    count: number;         // 해당 품목의 행 개수
    orderQty: number;      // 지시량 합계
    productQty: number;    // 생산량 합계
    badQty: number;        // 불량수량 합계
    acceptQty: number;     // 실적수량 합계
}

/**
 * 생산일자별 소계 계산 데이터 인터페이스
 */
export interface PRD3031_R01DateSubtotalData extends PRD3031_R01SubtotalData {
    productDt: string | undefined;   // 생산일자
    dateCount: number;     // 해당 일자의 행 개수
}

/**
 * 소계 행 타입 확인 헬퍼 함수들 (최적화된 버전)
 */
export const PRD3031_R01isSubtotalRow = (row: PRD3031_R01GridRowData): row is PRD3031_R01ItemSubtotalRow | PRD3031_R01DateSubtotalRow => {
    return row.isSubtotal === true;
};

export const PRD3031_R01isItemSubtotalRow = (row: PRD3031_R01GridRowData): row is PRD3031_R01ItemSubtotalRow => {
    return PRD3031_R01isSubtotalRow(row) && row.subtotalType === PRD3031_R01_SUBTOTAL_TYPES.ITEM;
};

export const PRD3031_R01isDateSubtotalRow = (row: PRD3031_R01GridRowData): row is PRD3031_R01DateSubtotalRow => {
    return PRD3031_R01isSubtotalRow(row) && row.subtotalType === PRD3031_R01_SUBTOTAL_TYPES.DATE;
};

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultProductResultData: PRD3031_R01SubtotalRow = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

    productResultNo: '',
    compCd: '',
    compNm: '',
    productDt: formatDate(new Date()),
    orderType: '',
    orderTypeNm: '',
    workplaceCd: '',
    workplaceNm: '',
    jobTeam: '',
    jobTeamNm: '',
    itemCd: '',
    itemStatus: '',
    itemNm: '',
    itemSpec: '',
    itemUnit: '',
    productOrderNo: '',
    orderQty: 0,
    productEmp: '',
    productEmpNm: '',
    workStartDt: toLocalDateTime(new Date()),
    workEndDt: undefined,
    empNm: '',
    productQty: 0,
    badQty: 0,
    acceptQty: 0,
    brandCd: '',
    brandNm: '',
    logicCenter: '',
    warehouseCd: '',
    warehouseNm: '',
    basOrderType: '',
    basOrderNo: '',
    basOrderItemNo: '',
    kpiYn: '',
    inspectQty: 0,
    inspectYn: 'N',

	count: 0,
    isSubtotal: true,
    subtotalType: PRD3031_R01_SUBTOTAL_TYPES.ITEM,
    level: PRD3031_R01_SUBTOTAL_LEVELS.ITEM,

    inserted: false,
    isModified: false,
    
    // 백엔드 추가 필드들
    startDate: undefined,
    endDate: undefined,
    insertUser: undefined,
    insertForm: undefined,
    insertDt: undefined,
    updateUser: undefined,
    updateForm: undefined,
    updateDt: undefined,
    codeEntity: null,
    remark: undefined
};
